import React from 'react';

export class AdstxtComponent extends React.Component {
  constructor(props) {
    super(props);
    this.record = props.record;
  }

  render() {
    return (
      <div>
      <h1>ads.txt</h1>
      nobid.io,{this.record.code},DIRECT
      33across.com, 0010b00002Mq2FYAAZ, DIRECT, bbea06d9c4d2853c<br/>
      yahoo.com, 57289, RESELLER, e1a5b5b6e3255540<br/>
      rhythmone.com, 2439829435, RESELLER, a670c89d4a324e47<br/>
      google.com, pub-1789253751882305, DIRECT, f08c47fec0942fa0<br/>
      google.com, pub-1835489473992347, RESELLER, f08c47fec0942fa0<br/>
      gumgum.com, 13926, DIRECT, ffdef49475d318a9<br/>
      onetag.com, 694e68b73971b58, DIRECT<br/>
      rubiconproject.com, 11006, RESELLER, 0bfd66d529a55807<br/>
      advertising.com, 28246, RESELLER<br/>
      advertising.com, 28246, RESELLER<br/>
      yahoo.com, 57872, DIRECT<br/>
      smartadserver.com,3447,DIRECT<br/>
      lijit.com, 273657, DIRECT, fafdf38b16bf6b2b<br/>
      sovrn.com, 273657, DIRECT, fafdf38b16bf6b2b<br/>
      xandr.com, 11429, DIRECT, f5ab79cb980f11d1<br/>
      xandr.com, 12701, DIRECT, f5ab79cb980f11d1<br/>
      rubiconproject.com, 13702, DIRECT, 0bfd66d529a55807<br/>
      video.unrulymedia.com, 3736557092, RESELLER<br/>
      rhythmone.com, 3736557092, RESELLER, a670c89d4a324e47<br/>
      nativo.com,5677,direct<br/>
      admanmedia.com, 812, DIRECT<br/>
      sonobi.com, 7ad1b9f952, RESELLER, d1a215d9eb5aee9e<br/>
      rhythmone.com, 1059622079, RESELLER, a670c89d4a324e47<br/>
      contextweb.com, 560606, RESELLER, 89ff185a4c4e857c<br/>
      yahoo.com, 58905, RESELLER, e1a5b5b6e3255540<br/>
      aol.com, 58905, RESELLER, e1a5b5b6e3255540<br/>
      appnexus.com, 13099, RESELLER<br/>
      amxrtb.com, 105199579, DIRECT<br/>
      indexexchange.com, 195491, RESELLER, 50b1c356f2c5c8fc<br/>
      <br/>
      <hr style={{width: '100%'}}></hr>
      <h1>app-ads.txt</h1>
      nobid.io,{this.record.code},DIRECT
      smartadserver.com,3447,DIRECT<br/>
      xandr.com, 11429, DIRECT, f5ab79cb980f11d1<br/>
      xandr.com, 12701, DIRECT, f5ab79cb980f11d1<br/>
      leanback.digital, ESS-C889, DIRECT, b1d30350acaf0176<br/>
      conversantmedia.com, 100218, RESELLER, 03113cd04947736d<br/>
      triplelift.com, 9029, RESELLER, 6c33edb13117fd86<br/>
      districtm.io, 101993, RESELLER, 3fd707be9c4527c3<br/>
      video.unrulymedia.com, 3736557092, RESELLER<br/>
      rhythmone.com, 3736557092, RESELLER, a670c89d4a324e47<br/>
      sonobi.com, 7ad1b9f952, RESELLER, d1a215d9eb5aee9e<br/>
      rhythmone.com, 1059622079, RESELLER, a670c89d4a324e47<br/>
      contextweb.com, 560606, RESELLER, 89ff185a4c4e857c<br/>
      appnexus.com, 9538, DIRECT<br/>
      hitapps.com, 8613985ec49eb8f757ae6439e879bb2a8403, RESELLER<br/>
      video.unrulymedia.com, 2188085156, DIRECT<br/>
      rhythmone.com, 2188085156, DIRECT, a670c89d4a324e47<br/>
      indexexchange.com, 182257, RESELLER<br/>
      appnexus.com, 6849, RESELLER<br/>
      rubiconproject.com, 15268, RESELLER<br/>
      spotxchange.com, 285547, RESELLER, 7842df1d2fe2db34<br/>
      spotx.tv, 285547, RESELLER, 7842df1d2fe2db34<br/>
      admixer.net, cbe33a9a-6915-4cd9-a8cb-971583ff94d3, DIRECT<br/>
      ssp.logan.ai, LG8, RESELLER<br/>
      pubmatic.com, 160846, RESELLER, 5d62403b186f2ace<br/>
      inmobi.com, 61d733c3779d43e590c51c8bc078e10c, RESELLER, 83e75a7ae333ca9d<br/>
      pubmatic.com, 159277, RESELLER, 5d62403b186f2ace<br/>
      advertising.com, 28605, RESELLER<br/>
      Improvedigital.com, 1699, RESELLER<br/>
      admixer.net, cbe33a9a-6915-4cd9-a8cb-971583ff94d3, DIRECT<br/>
      ssp.logan.ai, LG8, RESELLER<br/>
      aol.com, 57992, RESELLER, e1a5b5b6e3255540<br/>
      Yahoo.com, 57992, RESELLER, e1a5b5b6e3255540<br/>
      e-planning.net,ec771b05828a67fa,RESELLER,c1ba615865ed87b2<br/>
      <br/>
      </div>
    )
  }
}